
import { singularityStore } from "@/store/store";
import { aiJobController } from "@/types/singularity/ai-jobs";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {}
})
export default class AIJobManager extends Vue {
  get aiJobs() {
    return singularityStore.aiJobs;
  }

  runJob(id: number) {
    aiJobController.runJob(id);
  }

  abortJob(id: number) {
    aiJobController.abortJob(id);
  }

  clearAllJobs() {
    aiJobController.clearAllJobs();
  }
}
